// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from "./environment-type";
import { getBuildIdentifier } from "./get-build-identifier";
import { getConfig, GlobalEnvironmentConfig } from "./get-global-config";

// This file will be create by `scripts/version.ts` as part of the build process.
// It can be run manually for testing but DO NOT check in the generated file.
import versionInfo from "./version-info.json";

let config: GlobalEnvironmentConfig;

try {
  config = getConfig();
} catch (error) {
  const message = error instanceof Error ? error.message : String(error);
  throw new Error(
    `Config file is missing or incorrectly configured: ${message}\nAn example config is available at configs/config.local.js and should be copied to src/assets/config.js`,
  );
}

export const environment: Environment = {
  apiUrls: config.apiUrls,
  applicationInsights: config.applicationInsights,
  azureAD: config.azureAD,
  build: getBuildIdentifier({
    ...versionInfo,
    environment: config.environment,
  }),
  googleMapsApiKey: config.googleMapsApiKey,
  helpAssist: config.helpAssist,
  isProductionBuild: false,
  type: config.environment,
  version: versionInfo.version,
  ymsUrls: config.ymsUrls,
  autoExtendReservationLimitInDays: config.autoExtendReservationLimitInDays,
  noOfDaysForExtendingReservation: config.noOfDaysForExtendingReservation,
};
